    'use strict';
    var app = new Vue({
        el: '.reviews.vue',
        data: {
            page: 1,
            perPage: 5,
            reviews: [],
            selectedReview: null,
            rawReviews: [],
            photosUrl: 'https://cdn.stamped.io/uploads/photos',
            videosUrl: 'https://cdn.stamped.io/uploads/videos',
            apifyPhotosUrl: 'https://alt.hemway.com/uploads',
            apifyVideosUrl: 'https://alt.hemway.com/uploads'
        },
        mounted() {
            this.parseReviews();
            $('.vue').removeClass('hidden');
        },
        computed: {
            utils() {
                return Utils ? Utils : {};
            },
            summary() {
                const reviews = this.rawReviews;
                const total = reviews.length;
                let average = 0;
                let data = {
                    'star1': reviews.filter(item => parseInt(item.rating) == 1).length,
                    'star2': reviews.filter(item => parseInt(item.rating) == 2).length,
                    'star3': reviews.filter(item => parseInt(item.rating) == 3).length,
                    'star4': reviews.filter(item => parseInt(item.rating) == 4).length,
                    'star5': reviews.filter(item => parseInt(item.rating) == 5).length
                };
                if (total > 0) {
                    for (let i = 1; i <= 5; i++) {
                        average += data['star' + i] * i;
                    }
                    average = average / total;
                }
                data.total = total;
                data.average = average.toFixed(1).replace(/\.0/g, '');
                return data;
            },
            pages() {
                const total = this.reviews.length;
                const page = this.page;
                let pages = Array.from({ length: (total >= 5 ? 5 : total) }, (_, i) => i + 1);
                if (total <= 5 || page < 4) {
                    return pages;
                }
                if ((page - 2) > 0) {
                    pages = [page - 2, page - 1, page];
                }
                if ((page + 2) <= total) {
                    pages.push(page + 1);
                    pages.push(page + 2);
                } else if ((page + 1) <= total) {
                    pages.push(page + 1);
                    pages.unshift(pages[0] - 1);
                } else {
                    pages.unshift(pages[0] - 1);
                    pages.unshift(pages[0] - 1);
                }
                return pages;
            },
            media() {
                let reviews = this.rawReviews;
                let items = [];
                if (reviews.length == 0) {
                    return items;
                }
                for (let i = 0; i < reviews.length; i++) {
                    let review = reviews[i];
                    if ((review.imagesFileNamePublished.length > 0 || review.videosFileNamePublished.length > 0) && review.rating >= 4) {
                        items.push(review);
                        if (items.length >= 20) {
                            break;
                        }
                    }
                }
                return items;
            }
        },
        methods: {
            async getReviews() {
                const _this = this;
                const reviewTag = window.productTags.find(tag => tag.startsWith('Reviews_'));
                const productId = encodeURIComponent( reviewTag ? reviewTag.replace('Reviews_', '') : window.productType );
                let stampedResults = [];
                let amazonResults = [];
                try {
                    const stampedRes = await fetch('https://alt.hemway.com/api/index.php/review/list?productId=' + productId, {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' }
                    });
                    if (stampedRes.ok) {
                        const stampedData = await stampedRes.json();
                        if (Array.isArray(stampedData.results)) {
                            stampedResults = stampedData.results.map(item => {
                                item.imagesFileNamePublished = item.imagesFileNamePublished ? item.imagesFileNamePublished.split(',') : [];
                                item.videosFileNamePublished = item.videosFileNamePublished ? item.videosFileNamePublished.split(',') : [];
                                item.source = 'stamped';
                                return item;
                            });
                        }
                    }
                } catch (error) {
                    console.error('[STAMPED] Failed to fetch reviews:', error);
                }
                try {
                    const amazonRes = await fetch('https://alt.hemway.com/apify/api/index.php/review/list?productId=' + productId, {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' }
                    });
                    if (amazonRes.ok) {
                        const amazonData = await amazonRes.json();
                        if (Array.isArray(amazonData.results)) {
                            amazonResults = amazonData.results.map(item => {
                                item.imagesFileNamePublished = item.imagesFileName ? JSON.parse(item.imagesFileName) : [];
                                item.videosFileNamePublished = item.videosFileName ? JSON.parse(item.videosFileName) : [];
                                item.source = 'apify';
                                return item;
                            });
                        }
                    }
                } catch (error) {
                    console.error('[AMAZON] Failed to fetch reviews:', error);
                }
                let results = stampedResults.concat(amazonResults);    
                if (results.length) {
                    results = results.sort((a, b) => new Date(b.dateAdded) - new Date(a.dateAdded));
                    results = results.sort((a, b) => new Date(b.rating) - new Date(a.rating));
                    results = results.sort((a, b) => new Date(b.isFeatured) - new Date(a.isFeatured));
                }
                return { results: results };
            },
            parseReviews() {
                const _this = this;
                let items = [[]];
                let totalPages = 0;
                Promise.resolve(this.getReviews())
                .then((response) => {
                    _this.$set(_this, 'rawReviews', response.results);
                    if (!Array.isArray(response.results) || response.results.length === 0) {
                        return false;
                    }
                    totalPages = response.results.length / this.perPage;
                    totalPages = response.results.length % this.perPage > 0 ? (parseInt(totalPages) + 1) : totalPages;
                    let c = 1;
                    response.results.forEach(review => {
                        if (c > _this.perPage) {
                            items.push([]);
                            c = 1;
                        }
                        items[items.length - 1].push(review);
                        c++;
                    });
                    _this.reviews = items;
                    return items;
                }).then((reviews) => {
                    if (reviews && reviews.length > 0) {
                        _this.initReviewsSwiper();
                        _this.constructReviewOverview();
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
            },
            getRevieweeInitials( review ) {
                if ( ! review ) {
                    return '';
                }
                let arr = review.author.split( ' ' );
                let str = arr[0].charAt(0) + '' + ( arr.length == 1 && arr[0].length > 1 ? arr[0].charAt(1) : arr[ arr.length - 1 ].charAt(0) );
                return str;
            },
            paginate( val ) {
                let page = this.page;
                switch (val) {
                    case 'prev':
                        page--;
                        break;
                    case 'next':
                        page++;
                        break;
                    default:
                        page = val;
                }
                if ( ! ( page > this.reviews.length || page < 0 ) ) {
                    this.page = page;
                    setTimeout(() => {
                        $( 'html, body' ).animate({
                            scrollTop: $( '.reviews .anchor.two' ).offset().top
                        }, 1375);
                    }, 1);
                }
            },
            buildStar(star) {
                const average = parseFloat( this.summary.average );
                let str = 'icons8-star';
                switch (star) {
                    case 1:
                        if ( this.utils.inRange( average, 0.25, 0.74 ) ) {
                            str += '-half-empty';
                        }
                        if ( average >= 0.75 ) {
                            str += '-2';
                        }
                        break;
                    case 2:
                        if ( this.utils.inRange( average, 1.25, 1.74 ) ) {
                            str += '-half-empty';
                        }
                        if ( average >= 1.75 ) {
                            str += '-2';
                        }
                        break;
                    case 3:
                        if ( this.utils.inRange( average, 2.25, 2.74 ) ) {
                            str += '-half-empty';
                        }
                        if ( average >= 2.75 ) {
                            str += '-2';
                        }
                        break;
                    case 4:
                        if ( this.utils.inRange( average, 3.25, 3.74 ) ) {
                            str += '-half-empty';
                        }
                        if ( average >= 3.75 ) {
                            str += '-2';
                        }
                        break;
                    case 5:
                        if ( this.utils.inRange( average, 4.25, 4.74 ) ) {
                            str += '-half-empty';
                        }
                        if ( average >= 4.75 ) {
                            str += '-2';
                        }
                        break;
                }
                return str;
            },
            showReviewModal( review ) {
                this.selectedReview = review;
                setTimeout(() => {
                    $( '.reviews .modal' ).addClass( 'delay' );
                    setTimeout(function() {
                        $( '.reviews .modal' ).addClass( 'active' );
                    }, 100);
                }, 1);
            },
            hideReviewModal() {
                const _this = this;
                $( '.reviews .modal' ).removeClass( 'active' );
                setTimeout(function() {
                    _this.selectedReview = null;
                    $( '.reviews .modal' ).removeClass( 'delay' );
                }, 600);
            },
            initReviewsSwiper() {
                const swiperProductTwo = new Swiper( '.product .reviews .slider', {
                    containerModifierClass: 'slide-',
                    noSwipingClass: 'alt',
                    slideActiveClass: 'active',
                    slideBlankClass: 'blank',
                    slideClass: 'slide',
                    slideNextClass: 'next',
                    slidePrevClass: 'previous',
                    slideVisibleClass: 'visible',
                    wrapperClass: 'slides',
                    speed: 750,
                    spaceBetween: 12,
                    navigation: {
                        disabledClass: 'disabled',
                        nextEl: '.product .reviews .slider .buttons .next',
                        prevEl: '.product .reviews .slider .buttons .previous',
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 2,
                        },
                        600: {
                            slidesPerView: 3,
                        },
                        900: {
                            slidesPerView: 4,
                        }
                    }
                });
            },
            constructReviewOverview() {
                const $el = $( '.product .overview .content .form .blocks.one .rating.alt' );
                $el.html(
                    '<div class="text one">' + parseFloat( this.summary.average ).toFixed(1) + '</div>\
                      <div class="star"></div>\
                      <div class="text two">\
                          <a href="#reviews">' + this.utils.formatNumber( this.summary.total ) + ' ' + this.utils.setPlural( 'Review', this.summary.total ) + '</a>\
                      </div>'
                );
                for ( let index = 1; index <= 5; index++ ) {
                    $el.find( '.star' ).append(
                        '<div class="icon">\
                            <i class="icons8 ' + this.buildStar(index) + '"></i>\
                        </div>'
                    );
                }
                $el.parent().removeClass( 'hidden' );
            },
            getphotosUrl(source) {
                return 'apify' == source ? this.apifyPhotosUrl : this.photosUrl;
            },
            getvideosUrl(source) {
                return 'apify' == source ? this.apifyVideosUrl : this.videosUrl;
            }
        }
    });